import { render, staticRenderFns } from "./ErpcList.vue?vue&type=template&id=51b37f0b"
import script from "./ErpcList.vue?vue&type=script&lang=ts"
export * from "./ErpcList.vue?vue&type=script&lang=ts"
import style0 from "./ErpcList.vue?vue&type=style&index=0&id=51b37f0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports